import {
  WarmTransferTopBarActions,
  WarmTransferView,
  type WarmTransferDemoState,
} from '@elva/ui';
import { useState } from 'react';
import { usePageTopBar } from '@/app/layouts/pageTopBar';

export function WarmTransferPage() {
  const [demoState, setDemoState] = useState<WarmTransferDemoState>('active');

  usePageTopBar({
    actions: (
      <WarmTransferTopBarActions demoState={demoState} onDemoStateChange={setDemoState} />
    ),
  });

  return <WarmTransferView demoState={demoState} />;
}
